export const CopyToClipboard = (input: string) => {
  if (window.isSecureContext) {
    navigator.clipboard.writeText(input);
  } else {
    try {
      const textField = document.createElement("textarea");
      textField.innerText = input;
      document.body.appendChild(textField);
      textField.select();
      const successful = document.execCommand("copy");
      textField.remove();
      const msg = successful ? "successful" : "unsucessfull";
      console.log("Copy to clipboard was " + msg);
    } catch (err: any) {
      console.log("Could not copy to clipboard " + err.toString());
    }
  }
};
